// https://github.com/championswimmer/vuex-module-decorators

import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import auth from '@/store/modules/auth';
import global from '@/store/modules/global';
import link from '@/store/modules/link';
import { RootState } from '@/store/types';

Vue.use(Vuex);

const initialModules = {
  auth,
  global,
  link,
};

const saveLocal = (store: Store<RootState>) => {
  store.subscribe((mutation, state) => {
    localStorage.setItem('store', JSON.stringify(state));
  });
};

const storePattern = {
  modules: { ...initialModules },
};

export default new Vuex.Store({
  ...storePattern,
  mutations: {
    INITIALISE_STORE(state) {
      if (!localStorage.getItem('storeDefault')) {
        localStorage.setItem('storeDefault', JSON.stringify(state));
      }

      if (localStorage.getItem('store')) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store') as string)),
        );
      }
    },
    RESET_STATE(state) {
      this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem('storeDefault') as string)),
      );
    },
  },
  plugins: [saveLocal],
});
